import { render } from "./Aside.vue?vue&type=template&id=4c601e68&scoped=true&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import "./Aside.vue?vue&type=style&index=0&id=4c601e68&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c601e68"]])

export default __exports__